import React from "react";
import { useNavigate, useLocation } from "react-router";
import { Typography, useTheme } from "@mui/material";
import "./index.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ShareIcon from "@mui/icons-material/Share";
import { useQueryClient } from "@tanstack/react-query";
import { getMenu } from "../../lib/localStorage";
import LogoutIcon from "@mui/icons-material/Logout";
import Routes from "../../../app/routing/routes";
import { usePopup } from "../../hooks/usePopup";

interface Props {
  faqDesc?: any;
  fetchGenerateLink: () => void;
  token: any;
}

const Navbar: React.FunctionComponent<Props> = ({
  faqDesc,
  fetchGenerateLink,
  token,
}: Props) => {
  const navigate = useNavigate();
  const { showConfirmation } = usePopup();
  const path = useLocation();
  const locations = path.pathname;

  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);
  const host = window.location.protocol + "//" + window.location.host;

  let getBiller: any = getMenu();
  const biller = getBiller !== null ? JSON.parse(getBiller) ?? [] : [];
  let bookIdParams: any = params.get("bookId");

  const queryClient = useQueryClient();
  const notAllowedRoute = [
    "/paymentsuccess",
    "/paymentfailed",
    "/paymentpending",
    "/verifications",
    "/paymentlink",
    "/linkage",
    "/closed",
    "/login",
  ];

  const datas: any = queryClient.getQueryData(["datas"]);

  const onClickShare = () => {
    fetchGenerateLink();
  };

  const onClickFaq = () => {
    if (faqDesc && token) {
      queryClient.setQueryData(["data"], {
        data: faqDesc,
      });
      navigate("/faq");
    }
  };

  const onClickLogout = () => {
    showConfirmation(
      "Anda yakin ingin keluar?",
      "Anda harus memasukkan nomor hp dan password untuk masuk kembali.",
      onClickBackToApp
    );
  };

  const onClickTransaction = () => {
    if (token) {
      queryClient.setQueryData(["data"], {
        partnerId: token.partnerId,
        token: token.token,
        userId: token.userId,
      });
      navigate("/transaksi");
    }
  };

  const theme = useTheme();

  const onClickGoBack = () => {
    if (locations === "/rincianpembayaran") {
      return window.location.replace(`/`);
    } else {
      return navigate(-1);
    }
  };

  const onClickBackToApp = () => {
    window.localStorage.clear();
    window.location.href = host + '/';
  };

  if (!notAllowedRoute.includes(locations) && token) {
    return (
      <div className="appBar">
        <div className="navbar-wrapper">
          <div
            className="mainTxt"
            style={
              bookIdParams !== null
                ? { color: "black" }
                : { color: theme.palette.primary.main }
            }
          >
            {!locations.includes("solusiwebappsv2") && locations !== "/" && (
              <a onClick={onClickGoBack}>
                <ArrowBackIosIcon color="primary" className="backBtn" />
              </a>
            )}
            {Routes.map(({ path, name }) => {
              return (
                <div className="setDisplayTitlePage" key={path}>
                  {locations.includes(path) &&
                    locations !== "/voucherdetail" &&
                    name != "" &&
                    name}
                </div>
              );
            })}

            {locations === "/voucherdetail" && !!datas && datas.billername}
            {locations === "/" ? (
              "PPOB"
            ) : (
              <>
                {biller &&
                  biller.map((item: any) => {
                    if (locations.includes(item.pagesNameInApps)) {
                      return item.billerName;
                    }
                  })}
              </>
            )}
          </div>
          {(locations.includes("solusiwebappsv2") || locations === "/") && (
            <div className="productGrid">
              <a id="btn_logout" className="btnIcon" onClick={onClickLogout}>
                <LogoutIcon color="primary" className="imgIcon" />
              </a>
              <a
                id="btn_transaksi"
                className="btnIcon"
                onClick={onClickTransaction}
              >
                <ReceiptLongIcon color="primary" className="imgIcon" />
                <Typography color="primary" className="txtTransaksi">
                  Transaksi
                </Typography>
              </a>
            </div>
          )}
          {locations.includes("struk") && bookIdParams === null && (
            <div className="productGrid">
              <a className="btnIcon" onClick={onClickShare}>
                <ShareIcon className="imgIcon" color="primary" />
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
  return null;
};

export default React.memo(Navbar);
